import React, {createRef} from 'react';
import {Grid} from '@mantine/core';
import {useFormikContext} from "formik";
import MantineInputField from "../../../../FormikUtils/MantineInputField";
import PhoneInput from 'react-phone-number-input'
import MantineInputRefField from "../../../../FormikUtils/MantineInputRefField";
import MantineAutoCompleteField from "../../../../FormikUtils/MantineAutoCompleteField";
import useStyles from "../styles";

export default function TitularForm(props) {
    const classes = useStyles();
    const {values, setFieldValue} = useFormikContext();
    const ref = createRef();
    const {
        formField: {
            codigosLocalidad,
            nombre,
            apellido,
            telefono,
            email,
            dni,
        },
        localidades
    } = props;

    return (
        <React.Fragment>
            <Grid gutter="md" justify="center" align="center">
                <Grid.Col xs={12} sm={6}>
                    <MantineInputField
                        name={nombre.name}
                        label={nombre.label}
                        withAsterisk
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <MantineInputField
                        name={apellido.name}
                        label={apellido.label}
                        withAsterisk
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <div className={classes.field}>
                        <PhoneInput
                            defaultCountry="AR"
                            ref={ref}
                            inputComponent={MantineInputRefField}
                            name={telefono.name}
                            label={telefono.label}
                            value={values.telefono}
                            onChange={(e) => {
                                /** @namespace e.length **/
                                if (e && e.length > 12) {
                                    setFieldValue(telefono.name, e)
                                }
                            }}
                            withAsterisk
                        />
                    </div>
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <MantineInputField
                        name={dni.name}
                        label={dni.label}
                        withAsterisk
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <MantineInputField
                        name={email.name}
                        label={email.label}
                        withAsterisk
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <MantineAutoCompleteField
                        name={codigosLocalidad.name}
                        label={codigosLocalidad.label}
                        data={localidades}
                        searchable
                        withAsterisk
                    />
                </Grid.Col>


            </Grid>
        </React.Fragment>
    );
}
